// this is the version we are using with the generated API types
export const MAX_DOCKER_API_VERSION = 1.47;
